import { render, staticRenderFns } from "./UpdateApp.vue?vue&type=template&id=f5ddf170"
import script from "./UpdateApp.vue?vue&type=script&lang=js"
export * from "./UpdateApp.vue?vue&type=script&lang=js"
import style0 from "./UpdateApp.vue?vue&type=style&index=0&id=f5ddf170&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports